window.ontech = window.ontech || {};

const _checkExpiration = () => {
    // Decrement Session time left
    ontech.storage.sessionTimeLeft--;

    // Session Expired?
    if(ontech.storage.sessionTimeLeft === 0){
        // Clear timer
        clearInterval(ontech.storage.sessionTimeChecker);

        // ToDo: Add logic to prompt user to extend session by 15 minutes with counter of 30 sec to
        //       response before automatically clearing session. Refresh prompt every second to show
        //       countdown
    }

};

const _deserializePayload = (payload) => {
    // Is payload null?
    if(isUndefinedOrNull(payload)){
        return payload;
    }

    // Is it a serialized object?
    if(
        (payload.startsWith('{') && payload.endsWith('}'))
        || (payload.startsWith('[') && payload.endsWith(']'))
    ){
        return JSON.parse(payload);
    }


    if(payload.length > 0){
        if(isNumber(payload)) {
            return toFloat(payload);
        }

        if(isBoolean(payload)){
            return toBoolean(payload)
        }
    }

    return payload;
};

const _serializePayload = (payload) => {
  if(isUndefinedOrNull(payload) || typeof payload === 'string'){
      return payload;
  }

  if(typeof payload === 'object'){
      return JSON.stringify(payload);
  }

  return payload.toString();
}

const _setLength = function (){
    ontech.storage.length = localStorage.length + sessionStorage.length;
};

const _validateSession = function(sessions){
    const [localStorageSessionId, sessionStorageSessionId] = sessions;
    if(localStorageSessionId !== sessionStorageSessionId){
        // ToDo: Session IDs don't match. Notify user that they need to return to original window or
        //  restart the session via correct.
    }
}


ontech.storage = (function(){
    let module = {
        sessionTimeLeft: 15,
        sessionTimeChecker: null,
        length: 0,

        // public methods
        clear: function () {
            localStorage.clear();
            sessionStorage.clear();
            _setLength();
        },

        getItem: function(key){
            if(key === StorageConstants.SESSION_ID){
                return [
                    localStorage.getItem(key),
                    sessionStorage.getItem(key)
                ];
            }

            // return _deserializePayload(sessionStorage.getItem(key));
            return _deserializePayload(localStorage.getItem(key));
        },

        removeItem: function(key){
            // Remove key from all Storage
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        },

        removeStorageByPrefix: function(prefix, excludedNames = []) {
            for (let i = 0; i < localStorage.length; i++) {
                const name = localStorage.key(i);
                if (name.startsWith(prefix) && !excludedNames.includes(name)) {
                    this.removeItem(name);
                }
            }
            for (let i = 0; i < sessionStorage.length; i++) {
                const name = sessionStorage.key(i);
                if (name.startsWith(prefix) && !excludedNames.includes(name)) {
                    this.removeItem(name);
                }
            }
        },

        setItem: function (key, value){
            // Does the key require special action?
            if([StorageConstants.SESSION_ID].includes(key)){
                // If Session ID not already set in local storage then set it
                if(
                    key === StorageConstants.SESSION_ID
                    && isUndefinedOrNull(localStorage.getItem(key))
                ){
                   localStorage.setItem(key, value);
                }
            }

            // sessionStorage.setItem(key, _serializePayload(value));
            localStorage.setItem(key, _serializePayload(value));
        }
    }

    // Create a session ID on load.
    module.setItem(StorageConstants.SESSION_ID, generateUUID());

    // Make sure this window is the valid window
    _validateSession(module.getItem(StorageConstants.SESSION_ID));

    // Set expiration check.
    module.sessionTimeChecker = setTimeout(_checkExpiration, 60 * 1000);

    return module;
})();